/**
 * Standard Timezones List
 * Format: (UTC±XX:XX) Region - City/Description
 * 
 * This is the single source of truth for all timezone selections in the application.
 * Used in: User creation, User profile, Domain settings, and anywhere else timezones are needed.
 */

export const TIMEZONES = [
  // UTC
  { value: 'UTC', label: '(UTC+00:00) UTC - Coordinated Universal Time', offset: 0 },
  
  // Americas - Negative offsets (West of UTC)
  { value: 'Pacific/Midway', label: '(UTC-11:00) Pacific - Midway Island', offset: -11 },
  { value: 'Pacific/Honolulu', label: '(UTC-10:00) Pacific - Hawaii', offset: -10 },
  { value: 'America/Anchorage', label: '(UTC-09:00) America - Alaska', offset: -9 },
  { value: 'America/Los_Angeles', label: '(UTC-08:00) America - Pacific Time (US & Canada)', offset: -8 },
  { value: 'America/Vancouver', label: '(UTC-08:00) America - Vancouver, British Columbia', offset: -8 },
  { value: 'America/Tijuana', label: '(UTC-08:00) America - Tijuana, Baja California', offset: -8 },
  { value: 'America/Phoenix', label: '(UTC-07:00) America - Arizona (No DST)', offset: -7 },
  { value: 'America/Denver', label: '(UTC-07:00) America - Mountain Time (US & Canada)', offset: -7 },
  { value: 'America/Edmonton', label: '(UTC-07:00) America - Edmonton, Alberta', offset: -7 },
  { value: 'America/Chicago', label: '(UTC-06:00) America - Central Time (US & Canada)', offset: -6 },
  { value: 'America/Mexico_City', label: '(UTC-06:00) America - Mexico City', offset: -6 },
  { value: 'America/Winnipeg', label: '(UTC-06:00) America - Winnipeg, Manitoba', offset: -6 },
  { value: 'America/Regina', label: '(UTC-06:00) America - Saskatchewan (No DST)', offset: -6 },
  { value: 'America/New_York', label: '(UTC-05:00) America - Eastern Time (US & Canada)', offset: -5 },
  { value: 'America/Toronto', label: '(UTC-05:00) America - Toronto, Ontario', offset: -5 },
  { value: 'America/Montreal', label: '(UTC-05:00) America - Montreal, Quebec', offset: -5 },
  { value: 'America/Detroit', label: '(UTC-05:00) America - Detroit, Michigan', offset: -5 },
  { value: 'America/Indiana/Indianapolis', label: '(UTC-05:00) America - Indiana (East)', offset: -5 },
  { value: 'America/Bogota', label: '(UTC-05:00) America - Bogota, Colombia', offset: -5 },
  { value: 'America/Lima', label: '(UTC-05:00) America - Lima, Peru', offset: -5 },
  { value: 'America/Halifax', label: '(UTC-04:00) America - Atlantic Time (Canada)', offset: -4 },
  { value: 'America/Caracas', label: '(UTC-04:00) America - Caracas, Venezuela', offset: -4 },
  { value: 'America/Santiago', label: '(UTC-04:00) America - Santiago, Chile', offset: -4 },
  { value: 'America/St_Johns', label: '(UTC-03:30) America - Newfoundland', offset: -3.5 },
  { value: 'America/Sao_Paulo', label: '(UTC-03:00) America - São Paulo, Brazil', offset: -3 },
  { value: 'America/Buenos_Aires', label: '(UTC-03:00) America - Buenos Aires, Argentina', offset: -3 },
  { value: 'Atlantic/South_Georgia', label: '(UTC-02:00) Atlantic - South Georgia', offset: -2 },
  { value: 'Atlantic/Azores', label: '(UTC-01:00) Atlantic - Azores', offset: -1 },
  
  // Europe & Africa - Zero and positive offsets
  { value: 'Europe/London', label: '(UTC+00:00) Europe - London, UK', offset: 0 },
  { value: 'Europe/Dublin', label: '(UTC+00:00) Europe - Dublin, Ireland', offset: 0 },
  { value: 'Europe/Lisbon', label: '(UTC+00:00) Europe - Lisbon, Portugal', offset: 0 },
  { value: 'Africa/Casablanca', label: '(UTC+00:00) Africa - Casablanca, Morocco', offset: 0 },
  { value: 'Europe/Paris', label: '(UTC+01:00) Europe - Paris, France', offset: 1 },
  { value: 'Europe/Berlin', label: '(UTC+01:00) Europe - Berlin, Germany', offset: 1 },
  { value: 'Europe/Amsterdam', label: '(UTC+01:00) Europe - Amsterdam, Netherlands', offset: 1 },
  { value: 'Europe/Brussels', label: '(UTC+01:00) Europe - Brussels, Belgium', offset: 1 },
  { value: 'Europe/Madrid', label: '(UTC+01:00) Europe - Madrid, Spain', offset: 1 },
  { value: 'Europe/Rome', label: '(UTC+01:00) Europe - Rome, Italy', offset: 1 },
  { value: 'Europe/Vienna', label: '(UTC+01:00) Europe - Vienna, Austria', offset: 1 },
  { value: 'Europe/Zurich', label: '(UTC+01:00) Europe - Zurich, Switzerland', offset: 1 },
  { value: 'Europe/Stockholm', label: '(UTC+01:00) Europe - Stockholm, Sweden', offset: 1 },
  { value: 'Europe/Warsaw', label: '(UTC+01:00) Europe - Warsaw, Poland', offset: 1 },
  { value: 'Africa/Lagos', label: '(UTC+01:00) Africa - Lagos, Nigeria', offset: 1 },
  { value: 'Europe/Athens', label: '(UTC+02:00) Europe - Athens, Greece', offset: 2 },
  { value: 'Europe/Bucharest', label: '(UTC+02:00) Europe - Bucharest, Romania', offset: 2 },
  { value: 'Europe/Helsinki', label: '(UTC+02:00) Europe - Helsinki, Finland', offset: 2 },
  { value: 'Europe/Kyiv', label: '(UTC+02:00) Europe - Kyiv, Ukraine', offset: 2 },
  { value: 'Africa/Cairo', label: '(UTC+02:00) Africa - Cairo, Egypt', offset: 2 },
  { value: 'Africa/Johannesburg', label: '(UTC+02:00) Africa - Johannesburg, South Africa', offset: 2 },
  { value: 'Asia/Jerusalem', label: '(UTC+02:00) Asia - Jerusalem, Israel', offset: 2 },
  { value: 'Europe/Moscow', label: '(UTC+03:00) Europe - Moscow, Russia', offset: 3 },
  { value: 'Europe/Istanbul', label: '(UTC+03:00) Europe - Istanbul, Turkey', offset: 3 },
  { value: 'Asia/Baghdad', label: '(UTC+03:00) Asia - Baghdad, Iraq', offset: 3 },
  { value: 'Asia/Riyadh', label: '(UTC+03:00) Asia - Riyadh, Saudi Arabia', offset: 3 },
  { value: 'Africa/Nairobi', label: '(UTC+03:00) Africa - Nairobi, Kenya', offset: 3 },
  { value: 'Asia/Tehran', label: '(UTC+03:30) Asia - Tehran, Iran', offset: 3.5 },
  { value: 'Asia/Dubai', label: '(UTC+04:00) Asia - Dubai, UAE', offset: 4 },
  { value: 'Asia/Baku', label: '(UTC+04:00) Asia - Baku, Azerbaijan', offset: 4 },
  { value: 'Asia/Kabul', label: '(UTC+04:30) Asia - Kabul, Afghanistan', offset: 4.5 },
  { value: 'Asia/Karachi', label: '(UTC+05:00) Asia - Karachi, Pakistan', offset: 5 },
  { value: 'Asia/Tashkent', label: '(UTC+05:00) Asia - Tashkent, Uzbekistan', offset: 5 },
  { value: 'Asia/Kolkata', label: '(UTC+05:30) Asia - Mumbai, India', offset: 5.5 },
  { value: 'Asia/Colombo', label: '(UTC+05:30) Asia - Colombo, Sri Lanka', offset: 5.5 },
  { value: 'Asia/Kathmandu', label: '(UTC+05:45) Asia - Kathmandu, Nepal', offset: 5.75 },
  { value: 'Asia/Almaty', label: '(UTC+06:00) Asia - Almaty, Kazakhstan', offset: 6 },
  { value: 'Asia/Dhaka', label: '(UTC+06:00) Asia - Dhaka, Bangladesh', offset: 6 },
  { value: 'Asia/Yangon', label: '(UTC+06:30) Asia - Yangon, Myanmar', offset: 6.5 },
  { value: 'Asia/Bangkok', label: '(UTC+07:00) Asia - Bangkok, Thailand', offset: 7 },
  { value: 'Asia/Jakarta', label: '(UTC+07:00) Asia - Jakarta, Indonesia', offset: 7 },
  { value: 'Asia/Ho_Chi_Minh', label: '(UTC+07:00) Asia - Ho Chi Minh City, Vietnam', offset: 7 },
  { value: 'Asia/Hong_Kong', label: '(UTC+08:00) Asia - Hong Kong', offset: 8 },
  { value: 'Asia/Singapore', label: '(UTC+08:00) Asia - Singapore', offset: 8 },
  { value: 'Asia/Kuala_Lumpur', label: '(UTC+08:00) Asia - Kuala Lumpur, Malaysia', offset: 8 },
  { value: 'Asia/Shanghai', label: '(UTC+08:00) Asia - Shanghai, China', offset: 8 },
  { value: 'Asia/Taipei', label: '(UTC+08:00) Asia - Taipei, Taiwan', offset: 8 },
  { value: 'Australia/Perth', label: '(UTC+08:00) Australia - Perth', offset: 8 },
  { value: 'Asia/Seoul', label: '(UTC+09:00) Asia - Seoul, South Korea', offset: 9 },
  { value: 'Asia/Tokyo', label: '(UTC+09:00) Asia - Tokyo, Japan', offset: 9 },
  { value: 'Australia/Darwin', label: '(UTC+09:30) Australia - Darwin', offset: 9.5 },
  { value: 'Australia/Adelaide', label: '(UTC+09:30) Australia - Adelaide', offset: 9.5 },
  { value: 'Australia/Brisbane', label: '(UTC+10:00) Australia - Brisbane (No DST)', offset: 10 },
  { value: 'Australia/Sydney', label: '(UTC+10:00) Australia - Sydney', offset: 10 },
  { value: 'Australia/Melbourne', label: '(UTC+10:00) Australia - Melbourne', offset: 10 },
  { value: 'Pacific/Guam', label: '(UTC+10:00) Pacific - Guam', offset: 10 },
  { value: 'Pacific/Noumea', label: '(UTC+11:00) Pacific - Noumea, New Caledonia', offset: 11 },
  { value: 'Pacific/Auckland', label: '(UTC+12:00) Pacific - Auckland, New Zealand', offset: 12 },
  { value: 'Pacific/Fiji', label: '(UTC+12:00) Pacific - Fiji', offset: 12 },
  { value: 'Pacific/Tongatapu', label: '(UTC+13:00) Pacific - Tonga', offset: 13 },
]

/**
 * Whether ``value`` is a real IANA timezone that ``Intl`` accepts.
 * Rejects offset labels like ``UTC-08:00`` / ``UTC−08:00`` (ASCII or Unicode
 * minus) that were historically pasted into free-text God Mode fields and
 * crash the technician app with ``RangeError: Invalid time zone``.
 * @param {string|null|undefined} value
 * @returns {boolean}
 */
export function isValidIanaTimezone(value) {
  if (!value || typeof value !== 'string') return false
  const name = value.trim()
  if (!name) return false
  const upper = name.toUpperCase().replace(/\u2212/g, '-')
  if (
    (upper.startsWith('UTC+') || upper.startsWith('UTC-')
      || upper.startsWith('GMT+') || upper.startsWith('GMT-'))
    && upper !== 'UTC' && upper !== 'GMT'
  ) {
    return false
  }
  try {
    // Throws RangeError for unknown zones (including offset-style strings).
    Intl.DateTimeFormat('en-US', { timeZone: name }).format(new Date())
    return true
  } catch {
    return false
  }
}

/**
 * Return ``value`` when it is a usable IANA zone, otherwise ``fallback``.
 * @param {string|null|undefined} value
 * @param {string} [fallback='UTC']
 * @returns {string}
 */
export function coerceIanaTimezone(value, fallback = 'UTC') {
  if (isValidIanaTimezone(value)) return String(value).trim()
  if (isValidIanaTimezone(fallback)) return String(fallback).trim()
  return 'UTC'
}

/**
 * Get timezone by IANA value
 * @param {string} value - IANA timezone identifier (e.g., 'America/New_York')
 * @returns {Object|null} - Timezone object or null if not found
 */
export function getTimezoneByValue(value) {
  return TIMEZONES.find(tz => tz.value === value) || null
}

/**
 * Get timezone label by value
 * @param {string} value - IANA timezone identifier
 * @returns {string} - Label or the value itself if not found
 */
export function getTimezoneLabel(value) {
  const tz = getTimezoneByValue(value)
  return tz ? tz.label : value
}

/**
 * Search timezones by query
 * @param {string} query - Search query
 * @returns {Array} - Filtered timezones
 */
export function searchTimezones(query) {
  if (!query) return TIMEZONES
  
  const q = query.toLowerCase()
  return TIMEZONES.filter(tz => 
    tz.label.toLowerCase().includes(q) || 
    tz.value.toLowerCase().includes(q)
  )
}

/**
 * Group timezones by region
 * @returns {Object} - Timezones grouped by region
 */
export function getTimezonesGroupedByRegion() {
  const groups = {}
  
  TIMEZONES.forEach(tz => {
    const region = tz.value.split('/')[0]
    if (!groups[region]) {
      groups[region] = []
    }
    groups[region].push(tz)
  })
  
  return groups
}

/**
 * Format for Vuetify v-autocomplete
 * @returns {Array} - Array with title and value properties
 */
export function getTimezonesForVuetify() {
  return TIMEZONES.map(tz => ({
    title: tz.label,
    value: tz.value
  }))
}

/**
 * Get timezone offset in minutes for a given IANA timezone.
 * Returns POSIX-style offset: positive = east of UTC, negative = west.
 * e.g. America/New_York (UTC-5) returns -300, Europe/Moscow (UTC+3) returns 180.
 * This is the opposite of JS Date.getTimezoneOffset().
 * @param {string} tz - IANA timezone identifier (e.g. 'America/New_York')
 * @returns {number} - Offset in minutes
 */
export function getTimezoneOffsetMinutes(tz) {
  try {
    const now = new Date()
    const utc = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }))
    const local = new Date(now.toLocaleString('en-US', { timeZone: tz }))
    return Math.round((local - utc) / 60000)
  } catch {
    return -new Date().getTimezoneOffset()
  }
}

export default TIMEZONES






